export default "__VITE_ASSET__19e59f0f__"